import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import "rxjs/add/operator/timeoutWith";
import "rxjs/add/observable/defer"
import "rxjs/add/observable/throw"

import { DataViewModel } from '../../models/DataViewModel';
import { Login } from '../../models/account/Login';
import { UserInfo } from '../../models/account/UserInfo';
import { AuthenticationResult } from '../../models/account/authenticationResult';
import { ResetPasswordResult } from '../../models/account/resetPasswordResult';
import { ConfirmResetPasswordRequest } from '../../models/account/confirmResetPasswordRequest';
import { RequestResetPasswordRequest } from '../../models/account/requestResetPasswordRequest';
import { ValidateResetLinkResponse } from '../../models/account/validateResetLinkResponse';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

@Injectable()
export class AccountService {
    baseUrl: string;

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string,) {
        this.baseUrl = baseUrl;
    }

    public authenticate(login: Login): Observable<DataViewModel<AuthenticationResult>> {
        return this.http.post(this.baseUrl + 'api/Account/Login/', login, {withCredentials:true})
            .map(response => <DataViewModel<AuthenticationResult>>response)
            .timeoutWith(60000, Observable.defer(() => Observable.throw(Observable.throw('Login process timed out'))))
            .catch(this.handleError);
    }

    public confirmResetPassword(request: ConfirmResetPasswordRequest): Observable<DataViewModel<ResetPasswordResult>> {
        return this.http.post(this.baseUrl + 'api/Account/ConfirmResetPassword/', request)
            .map(response => <DataViewModel<ResetPasswordResult>>response)
            .timeoutWith(60000, Observable.defer(() => Observable.throw(Observable.throw('Reset process timed out'))))
            .catch(this.handleError);
    }

    public requestResetPassword(request: RequestResetPasswordRequest): Observable<DataViewModel<ResetPasswordResult>> {
        return this.http.post(this.baseUrl + 'api/Account/RequestResetPassword/', request)
            .map(response => <DataViewModel<ResetPasswordResult>>response)
            .timeoutWith(60000, Observable.defer(() => Observable.throw(Observable.throw('Reset process timed out'))))
            .catch(this.handleError);
    }

    public validateResetLink(linkId: string) : Observable<DataViewModel<ValidateResetLinkResponse>> {
        return this.http.get(this.baseUrl + 'api/Account/ValidateResetLink/' + linkId)
            .map(response => <DataViewModel<ValidateResetLinkResponse>>response)
            .catch(this.handleError);
    }

    public pairTwoFactorAuthenticationDevice(pairingCode: string): Observable<DataViewModel<any>> {
        return this.http.post(this.baseUrl + 'api/Account/PairTwoFactorAuthenticationDevice/' + pairingCode, null)
            .map(response => <DataViewModel<any>>response)
            .timeoutWith(60000, Observable.defer(() => Observable.throw(Observable.throw('Pairing process timed out'))))
            .catch(this.handleError);
    }

    public getTwoFactorAuthenticationPairingParameters(): Observable<DataViewModel<any>> {
        return this.http.get(this.baseUrl + 'api/Account/GetTwoFactorAuthenticationPairingParameters')
            .map(response => <DataViewModel<any>>response)
            .timeoutWith(60000, Observable.defer(() => Observable.throw(Observable.throw('Pairing process timed out'))))
            .catch(this.handleError);
    }

    public isAuthenticated(func: (user: UserInfo) => void): void {
        this.http.get(this.baseUrl + 'api/Account/IsAuthenticated/')
            .map(response => <DataViewModel<UserInfo>>response)
            .catch(this.handleError)
            .subscribe(response => {
                if (response.success) {
                    func(response.data);
                }
            });
    }

    private handleError(response: ErrorObservable) {
        console.error(response);

        if (response.error.status === 429)
          return Observable.throw(response.error || 'Try again later');

        return Observable.throw(response.error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/services/account/account.service.ts